module.exports = __webpack_public_path__ + "9cbde32fd6465abc9e3b26264a6d23f9.pdf";